export function SET_FILES(state, files) {
    state.files = files;
}

export function SET_USER_AUTH(state, files) {
    state.auth_user_files = files;
}
export function SET_FILES_PAGINATION(state, pagination) {
    state.pagination = pagination;
}
